<p-confirmDialog key="group" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="ibox-content GrayBackground">
	<div class="OptionGrid">
		<!--School-->
		<label>School:</label>
		<div>
			<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading() == true"> </caass-schoolselector>
		</div>

		<!--Group-->
		<label>Group:</label>
		<div class="GroupInfoGrid">
			<p-dropdown
				style="margin-left: 5px"
				[disabled]="IsLoading() == true"
				[options]="lstGroup"
				[(ngModel)]="Group"
				(ngModelChange)="onGroupChange($event)"
				optionLabel="GroupName"
				[filter]="true"
				filterBy="GroupName"
				[showClear]="false"
				placeholder="Select a Group"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="Group">
						<div class="form-control NoBorder" style="text-align: left" [style.color]="Group.Active == true ? 'Black' : 'Red'">
							{{ Group.GroupName }}
						</div>
					</div>
				</ng-template>
				<ng-template let-GroupItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left" [style.color]="GroupItem.Active == true ? 'Black' : 'Red'">
							{{ GroupItem.GroupName }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Student Count:</label>
			<label class="InfoText">{{ Group != undefined ? Group.StudentCount : "" }}</label>
		</div>

		<!--Start Date-->
		<label>Start Date:</label>
		<p-calendar
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			(ngModelChange)="onStartDateChange($event)"
			name="StartDate"
		></p-calendar>

		<!--End Date-->
		<label>End Date:</label>
		<p-calendar
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			(ngModelChange)="onEndDateChange($event)"
			name="EndDate"
		></p-calendar>

		<!--Show Voided-->
		<label>Show Voided:</label>
		<input
			[disabled]="IsLoading() == true"
			class="form-control"
			style="margin: 0px; width: 20px; height: 20px"
			type="checkbox"
			[(ngModel)]="ShowVoid"
			(ngModelChange)="onVoidChange($event)"
		/>
	</div>
</div>

<!--Table-->
<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddPoint()">Add Point</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onRedeemPoint()">
							Redeem Point
						</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onVoidPoint()">
							Void Transaction
						</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrintPoint()">Print</button>
						<button [disabled]="IsLoading() == true" class="btn btn-success" style="margin-left: 5px" (click)="onAddMissingPoint()">
							Add Missing
						</button>
						<button
							*ngIf="IsSU() == true"
							[disabled]="IsLoading() == true || IsSU() == false"
							class="btn btn-danger"
							style="margin-left: 5px"
							(click)="onDeletePoint()"
						>
							Delete Point (SU Only)
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstPointsGroupTransaction"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedPointsGroupTransaction"
						dataKey="PointsGroupTransactionID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--TransactionDT-->
								<th>
									<!-- <p-columnFilter type="text" field="TransactionDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--PointsTransactionTypeDesc-->
								<th>
									<p-columnFilter field="PointsTransactionTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPointsTransactionTypeDesc
												[ngModel]="value"
												[options]="lstPointsTransactionTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PointsItemDesc-->
								<th>
									<p-columnFilter id="PointsItemDesc" field="PointsItemDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPointsItemDesc
												[ngModel]="value"
												[options]="lstPointsItemDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PointsItemValue-->
								<th>
									<!-- <p-columnFilter type="text" field="PointsItemValue" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--IsVoidDesc-->
								<th>
									<p-columnFilter field="IsVoidDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterIsVoidDesc
												[ngModel]="value"
												[options]="lstIsVoidDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--AddStudentPromptDesc-->
								<!-- <th class="CheckColWidth">
                                    <p-columnFilter field="AddStudentPromptDesc" matchMode="equals" [showMenu]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown #filterAddStudentPromptDesc [ngModel]="value" [options]="lstAddStudentPromptDesc" (onChange)="filter($event.value)"
                                                placeholder="Any" [showClear]="true">
                                                <ng-template let-value pTemplate="item">
                                                    <span>{{value}}</span>
                                                </ng-template>
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>
                                </th> -->

								<!--AssignedCountDesc-->
								<th>
									<p-columnFilter type="text" field="AssignedCountDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--UnassignedCountDesc-->
								<th>
									<p-columnFilter type="text" field="UnassignedCountDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="TransactionDT">Date/Time<p-sortIcon field="TransactionDT"></p-sortIcon></th>
								<th pSortableColumn="PointsTransactionTypeDesc">Transaction Type<p-sortIcon field="PointsTransactionTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="PointsItemDesc">Point<p-sortIcon field="PointsItemDesc"></p-sortIcon></th>
								<th pSortableColumn="PointsItemValue">Point Value<p-sortIcon field="PointsItemValue"></p-sortIcon></th>
								<th pSortableColumn="IsVoidDesc">Voided?<p-sortIcon field="IsVoidDesc"></p-sortIcon></th>
								<!-- <th class="CheckColWidth" pSortableColumn="AddStudentPrompt">Auto-Assign?<p-sortIcon field="AddStudentPrompt"></p-sortIcon></th> -->
								<th pSortableColumn="AssignedCountDesc">Assigned Transaction<p-sortIcon field="AssignedCountDesc"></p-sortIcon></th>
								<th pSortableColumn="UnassignedCountDesc">Missing Transaction<p-sortIcon field="UnassignedCountDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-PointsGroupTransaction>
							<tr [pSelectableRow]="PointsGroupTransaction" (dblclick)="onRowDblClick(PointsGroupTransaction)">
								<td
									[style.color]="PointsGroupTransaction.IsVoid == true ? 'Red' : 'Black'"
									*ngFor="let col of cols"
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
								>
									{{ PointsGroupTransaction[col.field] }}
								</td>

								<!-- <td class="CheckColWidth">
                                    <div class="CenterText">
                                        <input type="checkbox" class="form-control CHK" [(ngModel)]="PointsGroupTransaction.AddStudentPrompt" (click)="onToggleAutoAssign(PointsGroupTransaction)">
                                    </div>
                                </td> -->

								<td
									[style.color]="PointsGroupTransaction.AllAssigned == true ? 'Green' : 'Red'"
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
								>
									{{ PointsGroupTransaction.AssignedCountDesc }}
								</td>

								<td
									[style.color]="PointsGroupTransaction.AllUnassigned == true ? 'Green' : 'Red'"
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
								>
									{{ PointsGroupTransaction.UnassignedCountDesc }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
